<template>
    <div class="section-container container-fixed">
        <div class="row justify-content-center">
            <div class="col-10">
                <section class="content-block">
                    <header class="header">
                        {{ 'TERMS.TOU' | translate }}
                    </header>
                    <p>
                        {{ 'TERMS.TOU_DESC' | translate }}
                    </p>
                </section>
                <section class="content-block">
                    <header class="header">
                        {{ 'TERMS.OWNERSHIP' | translate }}
                    </header>
                    <p>
                        Apollo Protocol does not own all the assets displayed on our website, 
                        therefore you must use your own judgement when interfacing with contracts. 
                        We do not verify, control or provide any warranty for purchases. 
                    </p>
                </section>
                <section class="content-block">
                    <header class="header">
                        {{ 'TERMS.PROMISE' | translate }}
                    </header>
                    <p>
                        {{ 'TERMS.PROMISE_DESC' | translate }}
                    </p>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'Rules',
    computed: {
        ...mapGetters({})
    }
}
</script>

<style scoped lang="less">
@import "../assets/less/generic.less";
</style>


// WEBPACK FOOTER //
// src/views/Terms.vue